var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { createSelector } from 'reselect';
import { initialState } from './reducer';
import { getConnectedLogic, mergeCustomEvents } from './helpers';
import { cleanPortName } from '../../utils/structure';
var selectStructureDomain = function (state) { return state.patchwork || initialState; };
export var selectViewState = function (state) { var _a; return ((_a = state === null || state === void 0 ? void 0 : state.patchwork) === null || _a === void 0 ? void 0 : _a.viewState) || initialState.viewState; };
export var selectFocalPatch = function (state) { var _a; return ((_a = state === null || state === void 0 ? void 0 : state.patchwork) === null || _a === void 0 ? void 0 : _a.focalPatch) || (initialState === null || initialState === void 0 ? void 0 : initialState.focalPatch); };
export var selectPatchwork = function (state) { var _a; return ((_a = state === null || state === void 0 ? void 0 : state.patchwork) === null || _a === void 0 ? void 0 : _a.patchwork) || initialState.patchwork; };
export var selectViews = function (state) { var _a; return ((_a = state === null || state === void 0 ? void 0 : state.patchwork) === null || _a === void 0 ? void 0 : _a.views) || initialState.views; };
export var selectViewsLoading = function (state) { var _a; return ((_a = state === null || state === void 0 ? void 0 : state.patchwork) === null || _a === void 0 ? void 0 : _a.views_loading) || initialState.views_loading; };
var selectDatasets = function (state) { var _a; return ((_a = state === null || state === void 0 ? void 0 : state.patchwork) === null || _a === void 0 ? void 0 : _a.datasets) || initialState.datasets; };
export var selectIntegrations = function (state) { var _a; return ((_a = state === null || state === void 0 ? void 0 : state.patchwork) === null || _a === void 0 ? void 0 : _a.integrations) || initialState.integrations; };
export var selectSelectedGroup = function (state) { var _a; return ((_a = state === null || state === void 0 ? void 0 : state.patchwork) === null || _a === void 0 ? void 0 : _a.selectedGroup) || initialState.selectedGroup; };
var selectGroupChanging = function (state) { var _a; return ((_a = state === null || state === void 0 ? void 0 : state.patchwork) === null || _a === void 0 ? void 0 : _a.selectGroupChanging) || initialState.selectGroupChanging; };
var selectAllGroups = function (state) { var _a; return ((_a = state === null || state === void 0 ? void 0 : state.patchwork) === null || _a === void 0 ? void 0 : _a.groups) || initialState.groups; };
export var selectLoaders = function (state) {
    var _a, _b, _c, _d;
    return ({
        datasets_loading: ((_a = state === null || state === void 0 ? void 0 : state.patchwork) === null || _a === void 0 ? void 0 : _a.datasets_loading) !== undefined
            ? (_b = state === null || state === void 0 ? void 0 : state.patchwork) === null || _b === void 0 ? void 0 : _b.datasets_loading
            : initialState.datasets_loading,
        integrations_loading: ((_c = state === null || state === void 0 ? void 0 : state.patchwork) === null || _c === void 0 ? void 0 : _c.integrations_loading) !== undefined
            ? (_d = state === null || state === void 0 ? void 0 : state.patchwork) === null || _d === void 0 ? void 0 : _d.integrations_loading
            : initialState.integrations_loading,
    });
};
export var selectCanvasOffset = function (state) { var _a; return ((_a = state === null || state === void 0 ? void 0 : state.patchwork) === null || _a === void 0 ? void 0 : _a.canvasOffset) || initialState.canvasOffset; };
export var selectCreatedView = function (state) { var _a, _b; return (_b = (_a = state === null || state === void 0 ? void 0 : state.patchwork) === null || _a === void 0 ? void 0 : _a.created_view) !== null && _b !== void 0 ? _b : initialState.created_view; };
export var selectTempNewPatch = function (state) { var _a; return ((_a = state === null || state === void 0 ? void 0 : state.patchwork) === null || _a === void 0 ? void 0 : _a.temp_new_patch) || initialState.temp_new_patch; };
export var selectGlobalStyles = function (state) { var _a; return ((_a = state === null || state === void 0 ? void 0 : state.patchwork) === null || _a === void 0 ? void 0 : _a.styles_data) || initialState.patchwork.styles_data; };
export var selectStructure = createSelector([
    selectStructureDomain,
    selectPatchwork,
    selectViews,
    selectDatasets,
    selectIntegrations,
    selectSelectedGroup,
    selectGroupChanging,
    selectAllGroups,
], function (subState, patchwork, views, datasets, integrations, selectedGroup, groupChanging, groups) {
    if (patchwork === void 0) { patchwork = { patches: [], edges: [] }; }
    if (views === void 0) { views = []; }
    if (datasets === void 0) { datasets = []; }
    if (integrations === void 0) { integrations = []; }
    if (selectedGroup === void 0) { selectedGroup = null; }
    if (groupChanging === void 0) { groupChanging = false; }
    if (groups === void 0) { groups = []; }
    if (groupChanging) {
        return {
            views: [],
            datasets: [],
            integrations: [],
            patchwork: {
                patches: [],
                edges: [],
                entrypoint: null,
                selectedGroup: null,
            },
            groupChanging: groupChanging,
        };
    }
    var viewIndex = views.reduce(function (acc, view) {
        acc[view.id] = view;
        return acc;
    }, {});
    var mappedDatasets = datasets.reduce(function (acc, dataset) {
        acc[dataset.id] = dataset;
        return acc;
    }, {});
    var _a = patchwork.patches, patches = _a === void 0 ? [] : _a, _b = patchwork.edges, edges = _b === void 0 ? [] : _b;
    var updatedPatches = patches.map(function (patch) {
        var _a, _b, _c;
        var selectedView = viewIndex[patch.view];
        var selectedDataset = mappedDatasets[patch.dataset];
        if (patch.type === 'view' && selectedView) {
            var mappedInputs = __spreadArray(__spreadArray([], (patch.inputs || []), true), selectedView.inputs, true).reduce(function (acc, input) {
                var _a;
                if (input) {
                    var tempInput = __assign({}, input);
                    if (!((_a = input === null || input === void 0 ? void 0 : input.name) === null || _a === void 0 ? void 0 : _a.includes('in:'))) {
                        tempInput.name = "in:".concat(input === null || input === void 0 ? void 0 : input.name);
                    }
                    acc[tempInput.name] = input;
                }
                return acc;
            }, {});
            var mappedOutputs = __spreadArray(__spreadArray(__spreadArray([], (patch.outputs || []), true), selectedView.outputs, true), ((selectedDataset === null || selectedDataset === void 0 ? void 0 : selectedDataset.outputs) || []), true).reduce(function (acc, output) {
                var _a;
                if (output) {
                    var tempOutput = __assign({}, output);
                    if (!((_a = output === null || output === void 0 ? void 0 : output.name) === null || _a === void 0 ? void 0 : _a.includes('out:'))) {
                        tempOutput.name = "out:".concat(output === null || output === void 0 ? void 0 : output.name);
                    }
                    acc[tempOutput.name] = tempOutput;
                }
                return acc;
            }, {});
            var inputs = Object.values(mappedInputs);
            var outputs = Object.values(mappedOutputs);
            return __assign(__assign({}, patch), { inputs: inputs, outputs: outputs });
        }
        if (patch.type === 'logic' && patch.logic === 'integration') {
            var integration = integrations.find(function (i) { return i.id === patch.settings.integrationId; });
            if (integration) {
                var _d = integration.methods, methods = _d === void 0 ? [] : _d;
                var method = methods.find(function (m) { return m.id === patch.settings.methodId; });
                if (method) {
                    var _e = method.status_codes, statusCodes = _e === void 0 ? [] : _e;
                    var mappedOutputs = __spreadArray(__spreadArray([], (patch.outputs || []), true), statusCodes.map(function (sc) { return ({ name: sc.name, type: 'event' }); }), true).reduce(function (acc, output) {
                        var _a;
                        if (output) {
                            var tempOutput = __assign({}, output);
                            if (!((_a = tempOutput === null || tempOutput === void 0 ? void 0 : tempOutput.name) === null || _a === void 0 ? void 0 : _a.includes('out:'))) {
                                tempOutput.name = "out:".concat(tempOutput.name);
                            }
                            acc[tempOutput.name] = tempOutput;
                        }
                        return acc;
                    }, {});
                    var outputs = Object.values(mappedOutputs);
                    return __assign(__assign({}, patch), { outputs: outputs });
                }
            }
        }
        if (patch.type === 'logic' && patch.logic === 'async_logic') {
            if ((_a = patch.settings.output_nodes) === null || _a === void 0 ? void 0 : _a.length) {
                var mappedOutputs = __spreadArray(__spreadArray([], (patch.outputs || []), true), patch.settings.output_nodes.map(function (opn) { return ({
                    name: opn.name,
                    type: 'event',
                }); }), true).reduce(function (acc, output) {
                    var _a;
                    if (output) {
                        var tempOutput = __assign({}, output);
                        if (!((_a = tempOutput === null || tempOutput === void 0 ? void 0 : tempOutput.name) === null || _a === void 0 ? void 0 : _a.includes('out:'))) {
                            tempOutput.name = "out:".concat(tempOutput.name);
                        }
                        acc[tempOutput.name] = tempOutput;
                    }
                    return acc;
                }, {});
                var outputs = Object.values(mappedOutputs);
                return __assign(__assign({}, patch), { outputs: outputs });
            }
        }
        if (patch.type === 'list') {
            var customOutputs = [];
            var altViewIds = Object.keys(((_c = (_b = patch.settings) === null || _b === void 0 ? void 0 : _b.condition) === null || _c === void 0 ? void 0 : _c.alternateViews) || {});
            altViewIds.push(patch.view);
            if (views.length && altViewIds.length) {
                customOutputs = mergeCustomEvents(views, altViewIds);
            }
            if (customOutputs === null || customOutputs === void 0 ? void 0 : customOutputs.length) {
                var mappedOutputs = __spreadArray(__spreadArray([], (patch.outputs || []), true), customOutputs.map(function (op) { return ({
                    name: op.name,
                    type: 'event',
                }); }), true).reduce(function (acc, output) {
                    var _a;
                    if (output) {
                        var tempOutput = __assign({}, output);
                        if (!((_a = tempOutput === null || tempOutput === void 0 ? void 0 : tempOutput.name) === null || _a === void 0 ? void 0 : _a.includes('out:'))) {
                            tempOutput.name = "out:".concat(tempOutput.name);
                        }
                        acc[tempOutput.name] = tempOutput;
                    }
                    return acc;
                }, {});
                var outputs = Object.values(mappedOutputs);
                return __assign(__assign({}, patch), { outputs: outputs });
            }
        }
        return patch;
    });
    var patchStartEdges = {};
    // find the logic blocks that are at the start of logic
    var startingLogic = updatedPatches.filter(function (patch) {
        if (patch.type !== 'logic') {
            return false;
        }
        // async_logic can't reside within a logic group
        if (patch.logic === 'async_logic') {
            return false;
        }
        var fromEdge = edges.find(function (edge) { return edge.to_patch === patch.id; });
        if (!fromEdge) {
            //when logic/logic block is not linked with view patch - it is a starting patch
            if (!patchStartEdges[patch.id]) {
                patchStartEdges[patch.id] = [];
            }
            return true;
        }
        var fromPatch = patches.find(function (p) { return p.id === fromEdge.from_patch; });
        if (!fromPatch) {
            return false;
        }
        if (fromPatch.type !== 'logic' || fromPatch.logic === 'async_logic') {
            if (!patchStartEdges[patch.id]) {
                patchStartEdges[patch.id] = [];
            }
            patchStartEdges[patch.id].push(fromEdge);
            return true;
        }
        return false;
    });
    var patchEndPatches = {};
    var patchMiddleEdges = {};
    var patchEndEdges = {};
    // find the connected blocks
    var connectedLogic = startingLogic.reduce(function (acc, patch) {
        if (acc[patch.id]) {
            return acc;
        }
        var _a = getConnectedLogic({
            patches: updatedPatches,
            edges: edges,
            patch: patch,
            connected: {
                patches: [patch],
                endEdges: [],
                middleEdges: [],
                endPatches: [],
            },
        }), logicBlocks = _a.patches, endEdges = _a.endEdges, middleEdges = _a.middleEdges, endPatches = _a.endPatches;
        patchEndPatches[patch.id] = endPatches;
        patchMiddleEdges[patch.id] = middleEdges;
        patchEndEdges[patch.id] = endEdges;
        // single patch logic does not need to be grouped
        if (logicBlocks.length <= 1) {
            return acc;
        }
        acc[patch.id] = logicBlocks.map(function (p) { return (__assign(__assign({}, p), { patch_group: patch.id })); });
        return acc;
    }, {});
    var uniquePatches = new Set();
    var uniqueEdges = new Set();
    // get edges for connected logic
    var _c = Object.keys(connectedLogic).reduce(function (acc, patchId) {
        var _a;
        var group = connectedLogic[patchId];
        // single patch logic does not need to be grouped
        if (!group || group.length <= 1) {
            return acc;
        }
        if (!acc.logicGroups[patchId]) {
            var groupEdges = patchMiddleEdges[patchId];
            // create a group patch
            var inPatch = group[0];
            var outPatch = group[group.length - 1];
            var outputs_1 = [];
            var endPatchOutputsMapped_1 = new Set();
            if (patchEndPatches[patchId] && patchEndPatches[patchId].length > 0) {
                var middleEdgesMap_1 = patchMiddleEdges[patchId].reduce(function (acc, middleEdge) {
                    acc["".concat(middleEdge.from_patch, ".").concat(middleEdge.from_arg)] =
                        middleEdge;
                    return acc;
                }, {});
                // go through end patches of the group and combine outputs
                patchEndPatches[patchId].forEach(function (patch) {
                    endPatchOutputsMapped_1.add(patch.id);
                    patch.outputs
                        .filter(function (output) {
                        return !("".concat(patch.id, ".").concat(output.name) in middleEdgesMap_1 ||
                            "".concat(patch.id, ".").concat(cleanPortName(output.name)) in
                                middleEdgesMap_1);
                    })
                        .forEach(function (output) {
                        var name = "".concat(patch.id, ":").concat(output.name);
                        var existingOutput = outputs_1.find(function (o) { return o.name === name; });
                        if (!existingOutput) {
                            outputs_1.push(__assign(__assign({}, output), { name: name, group_name: "".concat(patch.name, " (").concat(output.name, ")") }));
                        }
                    });
                });
            }
            // go through group patches and combine outputs of non-mapped edges
            group.forEach(function (patch) {
                if (!endPatchOutputsMapped_1.has(patch.id)) {
                    endPatchOutputsMapped_1.add(patch.id);
                    patch.outputs.forEach(function (output) {
                        // try to find a connected edge to this output
                        var alreadyMappedEdge = edges.find(function (e) {
                            return e.from_patch === patch.id &&
                                (e.from_arg === output.name ||
                                    cleanPortName(e.from_arg) === output.name);
                        });
                        if (!alreadyMappedEdge) {
                            // if there is nothing connected, add this output to the group patch
                            var name_1 = "".concat(patch.id, ":").concat(output.name);
                            var existingOutput = outputs_1.find(function (o) { return o.name === name_1; });
                            if (!existingOutput) {
                                outputs_1.push(__assign(__assign({}, output), { name: name_1, group_name: "".concat(patch.name, " (").concat(output.name, ")") }));
                            }
                        }
                    });
                }
            });
            //get the unique patches for the patch count
            var uniqueGroupIds_1 = [];
            var uniqueGroups = group.filter(function (element) {
                var isDuplicate = uniqueGroupIds_1.includes(element.id);
                if (!isDuplicate) {
                    uniqueGroupIds_1.push(element.id);
                    return true;
                }
            });
            var logic_count = group === null || group === void 0 ? void 0 : group.filter(function (item) { return (item === null || item === void 0 ? void 0 : item.logic) === 'custom_logic'; });
            // create the modified group patch
            var groupPatch = __assign(__assign({}, inPatch), { name: "Logic Group (".concat(uniqueGroups.length, ")"), is_custom_logic: !!(logic_count === null || logic_count === void 0 ? void 0 : logic_count.length), custom_logic_count: logic_count === null || logic_count === void 0 ? void 0 : logic_count.length, outputs: outputs_1, in_patch: patchId, out_patch: outPatch.id, type: 'logic_group' });
            // keep track of patches already assigned to a group
            group.forEach(function (p) { return uniquePatches.add(p.id); });
            // add modified patch to array
            acc.groupLogicPatches.push(groupPatch);
            // add related edges & modify end edges
            (_a = acc.groupLogicEdges).push.apply(_a, __spreadArray(__spreadArray(__spreadArray([], groupEdges, false), (patchStartEdges[patchId] || []), false), (patchEndEdges[patchId] || []).map(function (edge) { return (__assign(__assign({}, edge), { from_arg: "".concat(edge.from_patch, ":").concat(edge.from_arg), from_patch: patchId })); }), false));
            // create array of edges related to current group
            var newEdges = __spreadArray(__spreadArray(__spreadArray([], groupEdges, true), (patchStartEdges[patchId] || []), true), (patchEndEdges[patchId] || []), true);
            // keep track of edges already added to a group
            newEdges.forEach(function (e) { return uniqueEdges.add(e.id); });
            // create logic group
            acc.logicGroups[patchId] = {
                patches: group,
                edges: newEdges,
                entrypoint: patchId,
            };
        }
        return acc;
    }, {
        logicGroups: {},
        groupLogicPatches: [],
        groupLogicEdges: [],
    }), _d = _c.logicGroups, logicGroups = _d === void 0 ? {} : _d, _e = _c.groupLogicPatches, groupLogicPatches = _e === void 0 ? [] : _e, _f = _c.groupLogicEdges, groupLogicEdges = _f === void 0 ? [] : _f;
    // all ungrouped patches
    var ungroupedPatches = __spreadArray(__spreadArray([], updatedPatches.filter(function (p) { return !uniquePatches.has(p.id); }), true), groupLogicPatches, true);
    // all ungrouped edges
    var ungroupedEdges = __spreadArray(__spreadArray([], edges.filter(function (e) { return !uniqueEdges.has(e.id); }), true), groupLogicEdges, true);
    // if a group is selected, assign it to group
    var group = null;
    if (selectedGroup) {
        // provide a fallback in case there is a selected group but no group anymore
        group = logicGroups[selectedGroup] || {
            patches: [],
            edges: [],
            entrypoint: null,
        };
    }
    // if a group is selected, get all ungrouped logic blocks that aren't already
    // connected to something else
    var finalPatches = ungroupedPatches;
    var finalEdges = ungroupedEdges;
    var entrypoint = patchwork.entrypoint;
    if (group) {
        // get the group patches along with all lone logic blocks that don't have any edges
        finalPatches = __spreadArray(__spreadArray([], (group.patches || []), true), ungroupedPatches.filter(function (p) {
            return p.type === 'logic' &&
                !edges.find(function (e) { return [e.to_patch, e.from_patch].includes(p.id); });
        }), true);
        // create a list of ids of ungrouped patches
        // it's easier to check existence on a simple list with .includes
        var patchIds_1 = ungroupedPatches.map(function (p) { return p.id; });
        // get the edges that are connected to the ungrouped patches
        finalEdges = __spreadArray(__spreadArray([], (group.edges || []), true), ungroupedEdges.filter(function (e) {
            return patchIds_1.includes(e.from_patch) &&
                patchIds_1.find(function (id) { return id !== e.from_patch && id === e.to_patch; });
        }), true);
        (entrypoint = group.entrypoint);
    }
    return __assign(__assign({}, subState), { views: views, datasets: datasets, integrations: integrations, groups: groups, patchwork: __assign(__assign({}, patchwork), { entrypoint: entrypoint, patches: finalPatches, allPatches: patches, edges: finalEdges, originalEdges: edges, originalPatches: updatedPatches, logicGroups: logicGroups, group: group }), groupChanging: groupChanging });
});
export default selectStructure;
export { selectStructureDomain };
